/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { EmailDto } from './EmailDto';
import {
    EmailDtoFromJSON,
    EmailDtoFromJSONTyped,
    EmailDtoToJSON,
} from './EmailDto';
import type { TelephoneDto } from './TelephoneDto';
import {
    TelephoneDtoFromJSON,
    TelephoneDtoFromJSONTyped,
    TelephoneDtoToJSON,
} from './TelephoneDto';

/**
 * 
 * @export
 * @interface ContactSiegeDoublonSearch
 */
export interface ContactSiegeDoublonSearch {
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeDoublonSearch
     */
    idcontact?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeDoublonSearch
     */
    idsiegeSocial?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeDoublonSearch
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeDoublonSearch
     */
    prenom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeDoublonSearch
     */
    registreNational?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ContactSiegeDoublonSearch
     */
    dateNaissance?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeDoublonSearch
     */
    nationalite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeDoublonSearch
     */
    codesexe?: string | null;
    /**
     * 
     * @type {TelephoneDto}
     * @memberof ContactSiegeDoublonSearch
     */
    gsm?: TelephoneDto;
    /**
     * 
     * @type {TelephoneDto}
     * @memberof ContactSiegeDoublonSearch
     */
    telephone?: TelephoneDto;
    /**
     * 
     * @type {EmailDto}
     * @memberof ContactSiegeDoublonSearch
     */
    email?: EmailDto;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeDoublonSearch
     */
    remarque?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeDoublonSearch
     */
    idpersonne?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ContactSiegeDoublonSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ContactSiegeDoublonSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContactSiegeDoublonSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ContactSiegeDoublonSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeDoublonSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeDoublonSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ContactSiegeDoublonSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ContactSiegeDoublonSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ContactSiegeDoublonSearch interface.
 */
export function instanceOfContactSiegeDoublonSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactSiegeDoublonSearchFromJSON(json: any): ContactSiegeDoublonSearch {
    return ContactSiegeDoublonSearchFromJSONTyped(json, false);
}

export function ContactSiegeDoublonSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactSiegeDoublonSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcontact': !exists(json, 'idcontact') ? undefined : json['idcontact'],
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'prenom': !exists(json, 'prenom') ? undefined : json['prenom'],
        'registreNational': !exists(json, 'registreNational') ? undefined : json['registreNational'],
        'dateNaissance': !exists(json, 'dateNaissance') ? undefined : (json['dateNaissance'] === null ? null : new Date(json['dateNaissance'])),
        'nationalite': !exists(json, 'nationalite') ? undefined : json['nationalite'],
        'codesexe': !exists(json, 'codesexe') ? undefined : json['codesexe'],
        'gsm': !exists(json, 'gsm') ? undefined : TelephoneDtoFromJSON(json['gsm']),
        'telephone': !exists(json, 'telephone') ? undefined : TelephoneDtoFromJSON(json['telephone']),
        'email': !exists(json, 'email') ? undefined : EmailDtoFromJSON(json['email']),
        'remarque': !exists(json, 'remarque') ? undefined : json['remarque'],
        'idpersonne': !exists(json, 'idpersonne') ? undefined : json['idpersonne'],
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ContactSiegeDoublonSearchToJSON(value?: ContactSiegeDoublonSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcontact': value.idcontact,
        'idsiegeSocial': value.idsiegeSocial,
        'nom': value.nom,
        'prenom': value.prenom,
        'registreNational': value.registreNational,
        'dateNaissance': value.dateNaissance === undefined ? undefined : (value.dateNaissance === null ? null : value.dateNaissance.toISOString()),
        'nationalite': value.nationalite,
        'codesexe': value.codesexe,
        'gsm': TelephoneDtoToJSON(value.gsm),
        'telephone': TelephoneDtoToJSON(value.telephone),
        'email': EmailDtoToJSON(value.email),
        'remarque': value.remarque,
        'idpersonne': value.idpersonne,
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

